import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Radio, Row, Select, Space, Table, Tabs, Tooltip } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import SellOrDispose from '../modals/SellOrDispose';
import EventEmitter from '../utils/eventEmitter';
import PauseDepreciation from '../modals/PauseDepreciation';
import ModifyDepreciation from '../modals/ModifyDepreciation';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { MdEdit } from 'react-icons/md';
import getDepreciationDates from '../utils/getDepreciationDate';
import calculateProrataDepreciation from '../utils/calculateProrataDepreciation';
import useDeferredRevenueAPI from '../apis/DeferredRevenueAPI';
import EditableTable from '../components/EditableTable';
import { entriesColumns } from '../utils/tableMockData';



const columns = [
  {
    title: 'Reference',
    dataIndex: 'reference',
    key: 'reference',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  {
    title: 'Revenue',
    dataIndex: 'revenue',
    key: 'revenue',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  {
    title: 'Accummulated Revenue',
    dataIndex: 'accummulated_revenue',
    key: 'accummulated_revenue',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  {
    title: 'Next Period Value',
    dataIndex: 'next_period_value',
    key: 'next_period_value',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  // {
  //   title: 'Action',
  //   key: 'operation',
  //   fixed: 'right',
  //   width: 100,
  //   className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
  //   render: (_, record) => (
  //     <Link className='h-full w-full' to={'/assets'}>
  //       EDIT
  //     </Link>
  //   )
  // }
]

const periods = [{value: 'years', label: 'Year(s)'}, {value: 'months', label: 'Month(s)'}];
const accounts = [{code: '1002', name: 'Sales'}, {code: '20032', name: 'Treasury'}];
const taxes = [{value: '1002', name: 'Sales Tax'}, {code: '20032', name: 'Purchase Tax'}];



const DeferredRevenueChanges = () => {
  const { revenue_accounts, deferred_revenue_accounts, journals, deferred_revenue } = useLoaderData();
  deferred_revenue['acquisition_date'] = deferred_revenue.acquisition_date ? dayjs(deferred_revenue['acquisition_date'], 'YYYY-MM-DD') : '';
  deferred_revenue['start_depreciating_date'] = deferred_revenue.start_depreciating_date ? dayjs(deferred_revenue['start_depreciating_date'], 'YYYY-MM-DD') : '';
  const [formValue, setFormValue] = useState(deferred_revenue.seo ? {name: deferred_revenue.name, status: deferred_revenue.status} : {status: 'discard'});
  const [journalEntries, setJournalEntries] = useState([]);
  const [prorata, setProrata] = useState(false);
  const [form] = Form.useForm();
  const [revenueBoard, setRevenueBoard] = useState([]);
  const navigate = useNavigate();
  const { saveDeferredRevenue, updateRevenueStatus, update } = useDeferredRevenueAPI();
  const { success, error } = useOutletContext();
  const params = useParams();
  

  const toggleProrata = () => setProrata(!prorata);
  
  const onChangeName = (e) => setFormValue({...formValue, name: e.target.value});

  const handleSave = () => { 
    let data = form.getFieldsValue();
    data['name'] = formValue.name;
    data['seo'] = formValue.name.replace(/ /g, '-').toLowerCase();
    data['acquisition_date'] = new Date(dayjs(data.acquisition_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
    data['start_depreciating_date'] = new Date(dayjs(data.start_depreciating_date, 'YYYY-MM-DD').toDate()).toLocaleDateString();
    data['revenue_board'] = revenueBoard;
    saveDeferredRevenue(data, success);
  };

  const handleUpdate = () => { 
    let data = form.getFieldsValue();
    data['name'] = formValue.name;
    data['seo'] = formValue.name.replace(/ /g, '-').toLowerCase();
    data['acquisition_date'] = new Date(dayjs(data.acquisition_date, 'YYYY-MM-DD').toISOString()).toLocaleDateString();
    data['start_depreciating_date'] = new Date(dayjs(data.start_depreciating_date, 'YYYY-MM-DD').toDate()).toLocaleDateString();
    if (revenueBoard.length > 0) data['revenue_board'] = revenueBoard;
    update(data.seo, data, success);
  };

  const handleAction = () => { 
    const action = formValue.status;
    if (action === 'discard') {
      handleSave();
    }else if (action === 'update') {
      handleUpdate();
    }
  }
  const handleDiscard = () => setFormValue({...formValue, status: 'update'});

  const preProcessformData = () => {
    let formData = form.getFieldsValue();
    const duration = formData.duration.number*1;
    const original_value = formData.original_value;
    const residual_amount_recognize = formData.residual_amount_recognize
    return {duration, original_value, residual_amount_recognize};
  }

  const calculateDatesInPeriod = (period, duration, date) => {
    switch (period) {
      case 'years':
        return getDepreciationDates(date, duration, true);
      case 'months':
        return getDepreciationDates(date, duration, false);
    }
  }

  const computeRevenue = () => {
    let formData = form.getFieldsValue();
    let {duration, original_value, residual_amount_recognize } = preProcessformData();
    
    let dates = [];
    const date = dayjs(formData.start_depreciating_date, 'YYYY-MM-DD').toJSON();
    const acquisition_date = dayjs(formData.acquisition_date, 'YYYY-MM-DD').toJSON();

    dates = calculateDatesInPeriod(formData.duration.period, duration, date);
    let revenue_charge = parseFloat(original_value / duration).toFixed(2)*1;
    let prorataTemporisDepreciation = calculateProrataDepreciation(acquisition_date, date, revenue_charge);  

    // console.log(result)
    let revenue_board_ = [];
    if (prorata) {
      revenue_board_.push({
        reference: `${formValue.name} (prorata entry)`,
        date: new Date(acquisition_date).toLocaleDateString(), 
        revenue: prorataTemporisDepreciation, 
        accummulated_revenue: prorataTemporisDepreciation,
        next_period_value: original_value - prorataTemporisDepreciation
      });
      for(var i = 0; i <= duration-1; i++ ) {
        const accummulated_depreciation = (revenue_board_[i]['accummulated_revenue'] + revenue_charge).toFixed(2)*1; 
        const deferred_revenue_amount = parseFloat((original_value - accummulated_depreciation).toFixed(2)*1);
        let chargeObj = {reference: `${formValue.name} (${i+1}/${duration})`, date: dates[i], revenue: revenue_charge, accummulated_revenue: accummulated_depreciation, original_value, next_period_value: deferred_revenue_amount };
        revenue_board_.push(chargeObj);
      };
      // NORMALIZE END OF DEPRECIATION
      const lastTwoData = revenue_board_.slice(-2);
      revenue_board_[revenue_board_.length - 1]['revenue'] = lastTwoData[0]['next_period_value'];
      revenue_board_[revenue_board_.length - 1]['accummulated_revenue'] = original_value;
      revenue_board_[revenue_board_.length - 1]['next_period_value'] = 0;
      // END OF DEPRECIATION
    }else {
      for(var i = 1; i <= duration; i++ ) {
        const accummulated_depreciation = (revenue_charge * i).toFixed(2)*1
        const deferred_revenue_amount = (original_value - accummulated_depreciation).toFixed(2)*1;
        let chargeObj = {reference: `${formValue.name} (${i}/${duration})`, date: dates[i-1], revenue: revenue_charge, accummulated_revenue: accummulated_depreciation, original_value, next_period_value: deferred_revenue_amount };
        revenue_board_.push(chargeObj);
      };
    }

    setRevenueBoard(revenue_board_);
    form.setFieldValue('residual_amount_recognize', original_value);
    form.setFieldValue('deferred_revenue_amount', original_value);
    setFormValue({...formValue, deferred_revenue_amount: original_value });
  }


  useEffect(() => {
    EventEmitter.subscribe('save_deferred_revenue_response', data => {
      navigate('/accounting/deferred-revenues/'+data.seo);
      setFormValue({...formValue, status: data.status});
    });
    // EventEmitter.subscribe('sell_asset', data => {
    //   setFormValue({...formValue, status: data});
    // });

    EventEmitter.subscribe('updateStatusRevenueResponse', data => {
      setFormValue({...formValue, status: data.status});
    });

    return () => {
      EventEmitter.unsubscribe('save_deferred_revenue_response');
      EventEmitter.unsubscribe('updateStatusRevenueResponse');
    }
  },[])
  

  const handleConfirm = () => {
    updateRevenueStatus(deferred_revenue.seo, 'running', success);
  }
  const stopDepreciation = () => { };
  return (
    <div className='container mx-auto h-full pb-4' style={{ maxWidth: '900px' }}>
      <div className='flex justify-between mb-3'>
        <div className='flex '>
          <h3 className='font-bold'>
            <Link to={'/accounting/deferred-revenues'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Deferred Revenues</Link> / {params.action.replace(/-/g, ' ')}
          </h3>
          <Tooltip title={formValue.status === 'update' ? 'update' : 'save manually'} placement='rightBottom' className='ms-1'>
            <Button onClick={handleAction} type='text' htmlType='button'
              disabled={ (formValue.status === 'discard' || formValue.status === 'update') ? false : true}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={handleDiscard} type='text' htmlType='button'
              disabled={ formValue.status === 'draft' ? false : true}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip>
        </div>
      </div>
      <div className='flex justify-between align-center border-y-2' style={{paddingTop: '1px', paddingBottom: '1px'}}>
        {formValue.status === 'done' && <p className='m-0'>Deferred Revenue Completed</p>}
        {(formValue.status === 'draft' || formValue.status === 'save' || formValue.status === 'discard') && <div>
          <Button onClick={()=>handleConfirm('posted')} htmlType='button' className='me-1'>CONFIRM</Button> 
          <Button onClick={computeRevenue} htmlType='button' >COMPUTE REVENUE</Button>
        </div>}
        {formValue.status === 'running' && <div>
          <Button onClick={stopDepreciation} htmlType='button'>STOP</Button> 
          {/* <Button onClick={pauseDepreciation} htmlType='button' className='mx-1'>PAUSE DEPRECIATION</Button>
          <Button onClick={resumeModifyDepreciation} htmlType='button' >MODIFY DEPRECIATION</Button> */}
        </div>}
        {(formValue.status === 'draft' || formValue.status === 'running' || formValue.status === 'done') && (
          <div id='status-container '>
            <ul className='inner-wrapper'>
              <li
                className={
                  formValue.status === 'draft'
                    ? 'draft-disabled first draft draft-status'
                    : 'first draft-status draft-transparent'
                }
              >
                DRAFT
              </li>
              <li 
                className = { 
                  // formValue.status === 'running' ? 'posted posted-status' : 'posted-status posted-transparent'
                  formValue.status === 'running' ? 'middle middle-status' : 'middle-status middle-transparent'
                }
              >
                RUNNING
              </li>
              <li
                className={
                  formValue.status === 'done'
                    ? 'posted posted-status'
                    : 'posted-status posted-transparent'
                }
              >
                DONE
              </li>
            </ul>
          </div>
        )}
      </div>
      <div className='mt-5 p-3 bg-white shadow p-3'>
        <FloatingLabel 
          name='name'
          className='text-2xl' 
          variant="standard"
          disabled={(formValue.status!== 'discard' && formValue.status !== 'update') ? true : false}
          label="Deferred Revenue Name"
          value={formValue.name} 
          onChange={onChangeName}
        />
        <Tabs
          className='mt-3'
          // onChange={onChange}
          type='card'
          items={[
            {
              key: '1',
              label: 'Deferred Revenue Info',
              tabKey: 'info',
              children: 
              <Form
                form={form}
                labelAlign='left'
                labelCol={{span: 10}}
                labelWrap={true}
                initialValues={deferred_revenue.seo ? deferred_revenue : {
                  duration: {number: 1, period: 'years'},
                  prorata_temporis: false,
                  residual_amount_recognize: 0.00,
                  deferred_revenue_amount: 0.00
                }}
                disabled={(formValue.status!== 'discard' && formValue.status !== 'update') ? true : false}
                autoComplete="off"
                variant='borderless'
              >
                {/* <Form.Item label='Asset Name' name="name" labelAlign='' className='font-bold mb-2 column' required >
                  <Input className='border-x-0 border-t-0 input-outline-none font-normal' placeholder='eg. Computer' value={formValue.name} onChange={onChangeName}/>
                </Form.Item> */}
                

                <Row className='mt-5'>
                  <Col lg={{span: 11}} md={{span: 12}}>
                    <Badge className="text-slate-500 text-lg bg-transparent	">Asset Values</Badge>
                    <Form.Item label='Original Value' name="original_value" className='font-semibold text-gray-800 mb-2 column' required >
                      <InputNumber className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal' />
                    </Form.Item>
                    <Form.Item label='Acquisition Date' name="acquisition_date" className='font-semibold mb-2 column' required >
                      <DatePicker className='border-x-0 border-t-0 input-outline-none w-full border-0 font-normal'/>
                      {/* <Checkbox className='border-x-0 border-t-0 input-outline-none font-normal' checked={formValue.active} value={formValue.active} onChange={onChangeActive}/> */}
                    </Form.Item>
                  </Col>
                  <Col lg={{span: 11, offset: 1}} md={{span: 12}}>
                    <Badge className="text-slate-500 text-lg bg-transparent	">Current Values</Badge>
                    <Form.Item labelCol={{span: 12}} label='Residual Amount to Recognize' name={'residual_amount_recognize'} className='font-semibold columns mb-2' required >
                      <InputNumber className='border-x-0 border-t-0 input-outline-none font-normal' disabled={true}/>
                    </Form.Item>
                    <Form.Item labelCol={{span: 12}} label='Deferred Revenue Amount' name={'deferred_revenue_amount'} className='font-semibold columns mb-2' required >
                      <InputNumber className='border-x-0 border-t-0 input-outline-none font-normal' disabled={true}/>
                    </Form.Item>
                  </Col>
                </Row>
                <Row className='mt-5'>
                  <Col lg={{span: 11}} md={{span: 12}}>
                    <Badge className="text-slate-500 text-lg bg-transparent	">Depreciation Method</Badge>
                    <Form.Item label='Number of Recognition' className='font-semibold column mb-2' required >
                      <Space.Compact>
                        <Form.Item name={['duration', 'number']} noStyle>
                          <InputNumber className='input-outline-none font-normal' name='number' />
                        </Form.Item>
                        <Form.Item name={['duration', 'period']} noStyle>
                          <Select options={periods} className='border-b-2' name='period' style={{width: 100}}/>
                        </Form.Item>
                      </Space.Compact>
                    </Form.Item>  
                    <Form.Item label='Prorata Temporis' name={'prorata_temporis'} valuePropName='checked' className='font-semibold mb-2 column' required >
                      <Checkbox className='border-x-0 border-t-0 input-outline-none font-normal' name='isProrataTemporis' onClick={toggleProrata} />
                    </Form.Item>
                    <Form.Item label={'Start Depreciating'} name="start_depreciating_date" className='font-semibold mb-2' required>
                      <DatePicker className='border-x-0 border-t-0 input-outline-none border-0 font-normal w-full' />
                    </Form.Item>
                  </Col>
                  <Col lg={{span: 11, offset: 1}} md={{span: 12}}>
                    <Badge className="text-slate-500 text-lg bg-transparent	">Accounting</Badge>
                    <Form.Item labelCol={{span: 12}} label='Revenue Account' name={'revenue_account'} className='font-semibold columns mb-2' required >
                    <Select options={revenue_accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} className='input-outline-none'/>
                    </Form.Item>
                    <Form.Item labelCol={{span: 12,}} label='Deferred Revenue Account' name={'deferred_revenue_account'} className='font-semibold columns mb-2' required >
                      <Select options={deferred_revenue_accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} className='input-outline-none' />
                    </Form.Item>
                    <Form.Item labelCol={{span: 12}} label='Journal' name={'journal_id'} className='font-semibold columns mb-2' required >
                      <Select options={journals.map(journal => ({value: journal._id, label: journal.name}))} className='input-outline-none' />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            },
            revenueBoard.length > 0 && 
            {
              key: '2',
              label: 'Revenue Board',
              tabKey: 'board',
              forceRender: true,
              active: true,
              children: 
              <Table
                sticky
                dataSource={revenueBoard}
                columns={columns}
                scroll={{ y: 400,}}
                pagination={false}
              />
            },
            {
              key: '3',
              label: 'Related Sales',
              children:  
              <EditableTable
                dataSource={journalEntries}
                setJournalEntries={setJournalEntries}
                columns={entriesColumns}
                accounts={deferred_revenue_accounts}
                status={formValue.status}
              />
            }
          ]}
        />
      </div>
      <SellOrDispose />
      <PauseDepreciation />
      <ModifyDepreciation />
    </div>
  )
}

export default DeferredRevenueChanges;